import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PackagingsizeFilterCriteria from './PackagingsizeFilterCriteria'
import PackagingsizeList from './PackagingsizeList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PackagingsizeAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPackagingsizeDashboardPackagingsizeList } from '../../store/slice/PharmaSlice';

export default function PackagingsizeListView({setShowEdit,setPackagingsizeId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.packagingsizeDashboard);   

    const [filteredPackagingsizeList, setFilteredPackagingsizeList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { packagingsizeDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (packagingsizeDashboard.packagingsizeList.length>-1){
        setFilteredPackagingsizeList(packagingsizeDashboard.packagingsizeList);
        transformToCardFormat(packagingsizeDashboard.packagingsizeList, setCardList);
      }
    },[packagingsizeDashboard.packagingsizeList])

    useEffect(()=>{
          transformToCardFormat(filteredPackagingsizeList, setCardList);
      },[filteredPackagingsizeList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.formid==='' && filterCriteria.formname==='' ){
            setFilteredPackagingsizeList(packagingsizeDashboard.packagingsizeList);
            transformToCardFormat(packagingsizeDashboard.packagingsizeList, setCardList);

        } else {
            setFilteredPackagingsizeList(
                packagingsizeDashboard.packagingsizeList
                    .filter(packagingsize=> packagingsize.formid.toString().toUpperCase().includes(filterCriteria.formid.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(packagingsizeDashboard.filteredPackagingsizeList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PackagingsizeList
                    setShowEdit={setShowEdit}
                    setPackagingsizeId = {setPackagingsizeId}
                    tableList={filteredPackagingsizeList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}